import { render } from "./DeliveryLocationDisplay.vue?vue&type=template&id=6176f948"
import script from "./DeliveryLocationDisplay.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationDisplay.vue?vue&type=script&lang=js"

import "./DeliveryLocationDisplay.vue?vue&type=style&index=0&id=6176f948&lang=css"
script.render = render

export default script